<template>
  <div class="flex w-full flex-col gap-4 sm:grid sm:grid-cols-2 md:grid-cols-5">
    <payment-data-component @payerInput="payer = $event" :loadingCep="loadingCep" @validated="goToPayment" />
    <product-data-component
      :loadingInvoice="loadingInvoice"
      :checkoutData="checkoutData"
      :buttonDisabled="buttonDisabled"
      @validateData="validateData"
    />
  </div>
</template>

<script>
import customInputComponent from "./custom-input.component.vue";
import PaymentDataComponent from "./payment-data.component.vue";
import ProductDataComponent from "./product-data.component.vue";
import { v4 } from "uuid";
import { Encrypt } from "../../../shared/utils/encrypt";
import axios from "axios";
import customClass from "../../../shared/utils/modal-config";
import event_bus from "../../../shared/utils/event_bus";
// import { Auth } from "aws-amplify";

export default {
  components: {
    customInputComponent,
    PaymentDataComponent,
    ProductDataComponent,
  },

  props: {
    checkoutData: {
      type: Object,
    },
  },

  data() {
    return {
      payer: {
        name: "",
        email: "",
        cpf: "",
        phone: "",
        cep: "",
        number: "",
        street: "",
        neighborhood: "",
        city: "",
        uf: "",
        complement: "",
      },
      loadingCep: false,
      loadingInvoice: false,
      buttonDisabled: false,
    };
  },

  computed: {
    formattedCpf() {
      return this.payer.cpf.replaceAll(".", "").replaceAll("-", "");
    },
    formattedPhone() {
      return `+55${this.payer.phone.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "").replaceAll("-", "")}`;
    },
    formattedCep() {
      return this.payer.cep.replaceAll("-", "");
    },
  },

  methods: {
    validateData() {
      event_bus.$emit("VALIDATE");
    },
    goToPayment() {
      this.loadingInvoice = true;
      this.$recaptcha()
        .then((token) => {
          const uuidv4 = v4();
          const uuidKey = "".padStart(32, uuidv4.slice(0, 4));

          const checkoutCode = this.$route.params.checkout_code;
          const key = "".padStart(32, checkoutCode.slice(0, 4) + uuidv4.slice(0, 4));

          const p = this.payer;

          const payload = {
            user_full_name: p.name,
            user_email: p.email,
            user_cpf: this.formattedCpf,
            user_phone: this.formattedPhone,
            user_cep: this.formattedCep,
            user_address: p.street,
            user_address_complement: p.complement || " ",
            user_address_number: p.number,
            user_city: p.city,
            user_neighborhood: p.neighborhood,
            user_state: p.uf,
            extension_id: this.checkoutData.extension_id,
            checkout_code: this.$route.params.checkout_code,
            coupon_code: this.$route.query.coupon || this.checkoutData.coupon,
          };

          const body = {
            checkout_code: this.$route.params.checkout_code,
            uuidv4,
            p: Encrypt(JSON.stringify(payload), key),
          };

          const config = {
            headers: {
              authorization: uuidv4,
            },
            params: {
              hash: Encrypt(uuidv4, uuidKey),
              token,
            },
          };

          axios
            .post(this.$endpoint.CREATE_INVOICE_PUBLIC, body, config)
            .then((res) => {
              const data = res.data;
              this.$swal({
                title: "Redirecionando",
                iconHtml: `<div class="spinner animate-spin">${this.$icons.spinner_lg}</div>`,
                text: "Você será redirecionado para a nossa página de pagamentos em breve",
                timer: 3000,
                showConfirmButton: false,
                showCloseButton: false,
                allowOutsideClick: false,
                customClass: {
                  ...customClass,
                  icon: "!border-0",
                },
              })
                .then(() => {
                  window.location.href = data.msg.secure_url;
                })
                .catch((err) => {
                  console.error(err.data);
                  this.$swal("Erro", err.data, "error");
                });
            })
            .catch((err) => {
              console.error(err);
              this.$swal("Erro", err.response.data.msg, "error");
            })
            .finally(() => {
              this.loadingInvoice = false;
            });
        })
        .catch((err) => {
          console.error(err.data);
          this.$swal("Erro", err.data, "error");
        });
    },
    getCep(cep) {
      return axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    },
  },
  watch: {
    formattedCep: {
      handler(val) {
        if (val.length === 8) {
          this.loadingCep = true;
          this.getCep(val)
            .then((res) => {
              const data = res.data;
              this.payer.street = data.logradouro;
              this.payer.neighborhood = data.bairro;
              this.payer.city = data.localidade;
              this.payer.uf = data.uf;
            })
            .finally(() => {
              this.loadingCep = false;
            });
        }
      },
    },
  },
  mounted() {
    this.pageIsLoading = true;
    event_bus.$on("CHALLENGE_RENDERED", () => {
      this.loadingInvoice = false;
      this.buttonDisabled = true;
    });
    // Auth.currentAuthenticatedUser()
    //   .then(() => {
    //     this.$api.get(this.$endpoint.GET_USER_INFO).then((res) => {
    //       console.log(res);
    //     });
    //   })
    //   .catch(() => {})
    //   .finally(() => {
    //     this.pageIsLoading = false;
    //   });
  },
};
</script>

<style></style>
